/**
 * AdminDashboard - Admin Portal Layout
 * Uses shared AppLayout for consistency
 */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AppLayout } from '../../components/layout';
import { ADMIN_NAV } from '../../config/navigation';


const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    // Check admin session
    const session = localStorage.getItem('lk_admin_session');
    if (!session) {
      navigate('/admin/login');
      return;
    }
    setAdminUser(JSON.parse(session));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('lk_admin_session');
    navigate('/admin/login');
  };


  if (!adminUser) {
    return null;
  }

  return (
    <AppLayout
      role="admin"
      navItems={ADMIN_NAV}
      user={{
        name: adminUser?.email,
        email: adminUser?.email,
        role: 'admin',
      }}
      onLogout={handleLogout}
    />
  );
};

export default AdminDashboard;
